import gql from 'graphql-tag';

export const getInvestigationMetricsDocusketchRequestedQuery = gql`query InvestigationMetricsDocusketchRequestedConnection($filters: [InvestigationMetricsFilter], $orderBy: InvestigationMetricsOrderBy, $first: Int, $last: Int, $before: ID, $after: ID, $sortOrder: SortOrder) {
  investigationMetricsDocusketchRequestedConnection(first: $first, last: $last, before: $before, after: $after, filters: $filters, orderBy: $orderBy, sortOrder: $sortOrder) {
    pageInfo {
      limit
      offset
    }
    totalCount
    edges {
      cursor
      node {
        year
        data
      }
    }
  }
}`;
